import { useState, useCallback, useEffect, useRef } from "react";
import { api } from "../lib/api";

function read(key) {
  try { return JSON.parse(localStorage.getItem(key) || "[]"); } catch { return []; }
}
function write(key, val) {
  localStorage.setItem(key, JSON.stringify(val));
}

// Trim channel to the fields the backend expects.
function slim(ch) {
  return {
    uid: ch.uid, name: ch.name, url: ch.url, group: ch.group || "",
    country: ch.country || "", flag: ch.flag || "", language: ch.language || "", logo: ch.logo || "",
  };
}

export function useFavorites(email) {
  const key = `tvverse_fav_${email}`;
  const [favs, setFavs] = useState(() => read(key));
  const cloud = useRef(true);

  useEffect(() => {
    let active = true;
    api.get("/favorites")
      .then((r) => { if (!active) return; cloud.current = true; setFavs(r.data.favorites); write(key, r.data.favorites); })
      .catch((e) => { if (e?.response?.status === 503) { cloud.current = false; setFavs(read(key)); } });
    return () => { active = false; };
  }, [key]);

  const isFav = useCallback((uid) => favs.some((f) => f.uid === uid), [favs]);

  const toggle = useCallback((ch) => {
    setFavs((prev) => {
      const exists = prev.some((f) => f.uid === ch.uid);
      const next = exists ? prev.filter((f) => f.uid !== ch.uid) : [slim(ch), ...prev];
      write(key, next);
      if (cloud.current) {
        if (exists) api.delete(`/favorites/${ch.uid}`).catch(() => {});
        else api.post("/favorites", slim(ch)).catch(() => {});
      }
      return next;
    });
  }, [key]);

  return { favs, isFav, toggle };
}

export function useRecent(email) {
  const key = `tvverse_recent_${email}`;
  const [recent, setRecent] = useState(() => read(key));
  const cloud = useRef(true);

  useEffect(() => {
    let active = true;
    api.get("/recent")
      .then((r) => { if (!active) return; cloud.current = true; setRecent(r.data.recent); write(key, r.data.recent); })
      .catch((e) => { if (e?.response?.status === 503) { cloud.current = false; setRecent(read(key)); } });
    return () => { active = false; };
  }, [key]);

  const push = useCallback((ch) => {
    setRecent((prev) => {
      const next = [slim(ch), ...prev.filter((r) => r.uid !== ch.uid)].slice(0, 30);
      write(key, next);
      if (cloud.current) api.post("/recent", slim(ch)).catch(() => {});
      return next;
    });
  }, [key]);

  const clear = useCallback(() => {
    write(key, []);
    setRecent([]);
    if (cloud.current) api.delete("/recent").catch(() => {});
  }, [key]);

  return { recent, push, clear };
}
